import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { InternalOrderEnums } from 'src/app/enum/internal-order-enums';
import { ClassMaintenanceOrderEnum } from 'src/app/enum/maintenance-order-enum';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { MaintenanceOrderModel } from 'src/app/models/maintenance/maintenance-order.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { InternalOrderPrintModel } from 'src/app/models/shopping/internal-order-print.model';
import { InternalOrderModel } from 'src/app/models/shopping/internal-order.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { InternalOrderService } from 'src/app/services/shopping/internal-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-internal-order',
  templateUrl: './register-internal-order.component.html',
  styleUrls: ['./register-internal-order.component.scss'],
  standalone: false
})
export class RegisterInternalOrderComponent implements OnInit {

  articleCodeName: string = '';
  branchId: number = 0;
  companyId: number = 0;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  finishLoadingPrint: boolean = false;
  formInternalOrder: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  mainBranchByUser: BranchModel = new BranchModel();
  maintenanceOrderContract: MaintenanceOrderModel = new MaintenanceOrderModel();
  iconState: string = "pi pi-lock-open";
  internalOrderContract: InternalOrderModel = new InternalOrderModel();
  internalOrderPrintModel: InternalOrderPrintModel = new InternalOrderPrintModel();
  internalOrderId: number;
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listClassMaintenanceOrder: CustomListDropdown[] = [{ label: 'En Taller', value: 1 }, { label: 'En Sitio', value: 2 }];
  nameWindow: string = 'Captura Pedido Interno';
  titleState: string = "";
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  stateOpen: number = InternalOrderEnums.open;
  stateText: string = 'Abierta';
  swManagesInventoryOfSupplies: boolean = false;
  swQuotation: boolean = false;
  url: string = "internal-order";
  userAuthenticated: UserModel = new UserModel();

  constructor(private activatedRoute: ActivatedRoute,
    private articleService: ArticleService,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formatService: FormatService,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private internalOrderService: InternalOrderService,
    private location: Location,
    private maintenanceOrderService: MaintenanceOrderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
  ) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.validateForm(new InternalOrderModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.internalOrderId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async annulInternalOrder() {
    if (!this.validations()) return;

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', 'No es posible anular el pedido interno, no tiene ningún detalle.', 'Atención');
      return;
    }

    if (this.internalOrderContract.internalOrderState === InternalOrderEnums.close) {
      this.toastHandlerService.showToast('warning', 'No es posible anular, el pedido interno se encuentra cerrado.', 'Atención');
      return;
    }

    const response = await firstValueFrom(
      this.internalOrderService.getPermission(InternalOrderEnums.annulPermission)
    );

    if (!response) {
      this.showPermissionError('Anular');
      return;
    }

    Swal.fire({
      title: 'Atención',
      text: 'Al anular el pedido, se eliminará su detalle (artículos). ¿Está seguro de que desea anularlo?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.internalOrderContract = await firstValueFrom(this.internalOrderService.annulInternalOrder(this.internalOrderContract));
        this.validateForm(this.internalOrderContract);
        this.toastHandlerService.showToast('success', 'El pedido interno se anuló exitosamente.', '');
      }
    });
  }

  private showPermissionError(action: string): void {
    this.toastHandlerService.showToast('error', `El usuario no tiene permisos para ${action} un pedido interno. Comuníquese con el administrador del sistema.`, 'Atención');
  }

  changeBranch(branchId: number) {
    this.internalOrderId = 0;
    const modelInternalOrder = new InternalOrderModel();
    modelInternalOrder.branchId = branchId;
    this.validateForm(modelInternalOrder);
  }

  async changeConsecutive() {
    let consecutive = this.formInternalOrder.get("consecutive")?.value;
    const branchId = this.formInternalOrder.get("branchId")?.value;

    if (this.internalOrderContract.consecutive == consecutive) return;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    if (consecutive == null) {
      this.resetInternalOrder(branchId);
      return;
    }

    try {
      this.internalOrderContract = await firstValueFrom(this.internalOrderService.getInternalOrderByKeysAsync(branchId, consecutive));
      this.internalOrderId = this.internalOrderContract.internalOrderId;
      this.validateForm(this.internalOrderContract);
      this.location.replaceState(`/internal-order/register/${this.internalOrderId}`);
    } catch (error) {
      this.handleInternalOrderNotFound(branchId, consecutive);
      console.error('Error al buscar el pedido interno por campos de recuperación.', error);
    }
  }

  changeMaintenanceOrderClass() {
    this.formInternalOrder.get("maintenanceOrderConsecutive")?.patchValue(null);
    this.formInternalOrder.get("maintenanceOrderId")?.patchValue(null);
    this.articleCodeName = '';
  }

  async changeMaintenanceOrderConsecutive() {
    const branchId = this.formInternalOrder.get("branchId")?.value;
    const maintenanceOrderClass = this.formInternalOrder.get("maintenanceOrderClass")?.value;
    const maintenanceOrderConsecutive = this.formInternalOrder.get("maintenanceOrderConsecutive")?.value;

    if (!maintenanceOrderClass || isNaN(maintenanceOrderClass)) {
      this.toastHandlerService.showToast('warning', 'Seleccione una clase de orden de mantenimiento.');
      return;
    }

    try {
      this.maintenanceOrderContract = await firstValueFrom(
        this.maintenanceOrderService.getMaintenanceOrderByKeysAsync(maintenanceOrderConsecutive, branchId, maintenanceOrderClass)
      );
      this.formInternalOrder.get("maintenanceOrderId")!.setValue(this.maintenanceOrderContract.maintenanceOrderId);
      this.setArticle(this.maintenanceOrderContract.articleId);
    } catch (error) {
      this.formInternalOrder.get("maintenanceOrderId")!.setValue(null);
      this.articleCodeName = '';
      console.error('Error al buscar la orden de mantenimiento por claves.', error);
    }
  }

  async changeState() {
    if (!this.validations()) return;

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', 'No es posible cerrar el pedido interno, no tiene ningún detalle.', 'Atención');
      return;
    }

    const isOpen = this.internalOrderContract.internalOrderState === InternalOrderEnums.open;
    const permission = isOpen ? InternalOrderEnums.closePermission : InternalOrderEnums.openPermission;
    const title = isOpen ? 'Cerrar' : 'Abrir';
    const response = await firstValueFrom(this.internalOrderService.getPermission(permission));
    if (!response) {
      this.showPermissionError(title);
      return;
    }
    try {
      this.internalOrderContract = await firstValueFrom(this.internalOrderService.setInternalOrderState(this.internalOrderContract.internalOrderId));
      this.validateForm(this.internalOrderContract);
      this.toastHandlerService.showToast('success', 'El estado del pedido interno se modificó exitosamente.');
    } catch (error) {
      console.error('Error al cambiar el estado del pedido interno.', error);
    }
  }

  private resetInternalOrder(branchId: number): void {
    this.internalOrderId = 0;
    this.internalOrderContract = new InternalOrderModel();
    this.internalOrderContract.branchId = branchId;
  }

  private handleInternalOrderNotFound(branchId: number, consecutive: number): void {
    this.internalOrderContract = new InternalOrderModel();
    this.internalOrderContract.internalOrderId = 0;
    this.internalOrderContract.branchId = branchId;
    this.internalOrderContract.consecutive = consecutive;
  }

  async createNewInternalOrder() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear pedidos internos. Comuníquese con el administrador del sistema.', 'Atención');
      return;
    }
    this.internalOrderContract = new InternalOrderModel();
    this.internalOrderId = 0;
    this.internalOrderContract.branchId = this.branchId;
    this.internalOrderContract.consecutive = 0;
    this.internalOrderContract.responsible = `${this.userAuthenticated.firstName} ${this.userAuthenticated.lastName}`;
    this.quantityDetails = 0;
    await this.validateForm(this.internalOrderContract);
    this.location.replaceState(`/internal-order/register`);
  }

  async deleteInternalOrder() {
    if (!this.validations()) return;

    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', 'No es posible eliminar el pedido interno tiene detalle.', 'Atención');
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: `¿Realmente desea eliminar el pedido interno ${this.internalOrderContract.consecutive}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.internalOrderService.deleteInternalOrder(this.internalOrderContract.internalOrderId));
        this.toastHandlerService.showToast('success', 'El pedido interno fue eliminado exitosamente.', '');
        this.createNewInternalOrder();
      } catch (error) {

        console.error('Error al eliminar el pedido interno.', error);
      }
    }
  }

  async editInternalOrder() {
    await this.getInternalOrderById();
    this.validateForm(this.internalOrderContract);
    this.branchId = this.internalOrderContract.branchId;
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async getAllLists() {
    try {
      const [branches] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync())
      ]);
      this.listBranches = branches;

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;

    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        validBranch = branchId;
      }
    }
    this.branchId = validBranch ?? 0;
    this.formInternalOrder.controls["branchId"].patchValue(validBranch);

    if (reload) {
      this.changeBranch(this.branchId);
    }
  }

  async getButtonClick(buttonClick: any) {
    let consecutive = this.formInternalOrder.get("consecutive")?.value;
    const branchId = this.formInternalOrder.get("branchId")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }

    consecutive = consecutive === 0 ? null : consecutive;
    this.handleInternalOrderNavigation(buttonClick, branchId, consecutive)
  }

  private async handleInternalOrderNavigation(buttonClick: any, branchId: number, consecutive: number | null) {
    const actionMap: Record<string, () => Promise<InternalOrderModel>> = {
      first: () => firstValueFrom(this.internalOrderService.getFirstInternalOrderByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.internalOrderService.getPreviusInternalOrderByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.internalOrderService.getNextInternalOrderByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.internalOrderService.getLastInternalOrderByKeysAsync(branchId)),
    };

    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetInternalOrder(branchId);
      return;
    }

    try {
      const internalOrder = await action();
      this.internalOrderContract = internalOrder;
      this.internalOrderId = internalOrder.internalOrderId;
      this.validateForm(internalOrder);
      this.location.replaceState(`/internal-order/register/${this.internalOrderId}`);
    } catch (error) {
      this.handleInternalOrderNotFound(branchId, 0);
      console.error(`Error al buscar el pedido interno (${buttonClick.target.id}).`, error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    this.mainBranchByUser = await firstValueFrom(
      this.userAuthenticatedService.branchObservable.pipe(
        filter(branch => branch && branch.branchId !== 0)
      )
    );
    this.companyId = this.mainBranchByUser.companyId;
  }

  async getFirstBranchEnterprise() {
    try {
      this.getBranch(this.mainBranchByUser.branchId, false);
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.internalOrder));
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.swManagesInventoryOfSupplies = response.some(x => x.name === "ManejaInventarioDeInsumos");
        this.swQuotation = response.some(x => x.name === GeneralParameters.quotationsModule);
        const swMaintenanceOrderScheduled  = response.some(x => x.name === "OrdenMatenimientoProgramada");
        //Valido mantenimiento programado
        if (swMaintenanceOrderScheduled) {
                  this.listClassMaintenanceOrder.push({ label: 'Programada', value: ClassMaintenanceOrderEnum.programada });
        }
      });

      resolve(true);
    });
  }

  async getInternalOrderById() {
    try {
      this.internalOrderContract = await firstValueFrom(this.internalOrderService.getInternalOrderById(this.internalOrderId));
      this.internalOrderId = this.internalOrderContract.internalOrderId;
    } catch (error) {
      console.error('Error al buscar el pedido interno.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      this.getGeneralParametersByCompany();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InternalOrder));
  }

  async handleInitialState() {
    if (this.internalOrderId !== null && this.internalOrderId !== 0) {
      this.editInternalOrder();
    } else {
      await this.getFirstBranchEnterprise();
      this.createNewInternalOrder();
    }
  }


  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.internalOrderId != 0 && this.internalOrderId != null) {
      this.router.navigate(['/internal-order/register/', this.internalOrderId]);
    } else {
      this.router.navigate(['/internal-order/register']);
    }
  }

  async send(): Promise<any> {
    if (this.disabledForm) {
      this.toastHandlerService.showToast('warning', 'No es posible guardar, el pedido interno no está ABIERTO.', 'Atención');
      return;
    }

    Object.keys(this.formInternalOrder.controls).forEach(key => {
      const control = this.formInternalOrder.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });


    if (this.formInternalOrder.valid) {
      const modelInternalOrder = this.formInternalOrder.getRawValue();
      modelInternalOrder.observation = modelInternalOrder.observation || null;
      modelInternalOrder.responsible = modelInternalOrder.responsible === "" ? null : modelInternalOrder.responsible;
      if (this.internalOrderId == 0) {
        try {
          const response = await firstValueFrom(this.internalOrderService.createInternalOrder(modelInternalOrder));
          this.toastHandlerService.showToast('success', 'El pedido interno fue creado exitosamente.', '');
          this.internalOrderContract = response;
          this.internalOrderId = this.internalOrderContract.internalOrderId;
          this.validateForm(this.internalOrderContract);
          this.location.replaceState(`/internal-order/register/${this.internalOrderId}`);
        } catch (error) {
          console.error('Error al crear el pedido interno.', error);
        }
      } else {
        this.internalOrderContract.alterNumber = modelInternalOrder.alterNumber;
        this.internalOrderContract.dateInternalOrder = modelInternalOrder.dateInternalOrder;
        this.internalOrderContract.responsible = modelInternalOrder.responsible;
        this.internalOrderContract.observation = modelInternalOrder.observation;
        this.internalOrderContract.maintenanceOrderId = modelInternalOrder.maintenanceOrderId;

        try {
          const response = await firstValueFrom(this.internalOrderService.updateInternalOrder(this.internalOrderContract));
          this.toastHandlerService.showToast('success', 'El pedido interno fue modificado exitosamente.', '');
          this.internalOrderContract = response;
          this.validateForm(this.internalOrderContract);
        } catch (error) {
          console.error('Error al actualizar el pedido interno.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }

  }

  async setArticle(articleId: number) {
    try {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      this.articleCodeName = article ? `${article.code} - ${article.name}` : '';
    } catch (error) {
      console.error('Error al buscar el artículo y asignarlo al formulario.', error);
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      dateInternalOrder: 'El campo fecha es obligatorio.',
      responsible: 'El campo responsable es obligatorio y permite máximo 250 carateres.',
      observation: 'El campo observación permite máximo 250 carateres.',
    };

    Object.keys(controlMessages).forEach(control => {
      if (this.formInternalOrder.controls[control].invalid) {
        this.toastHandlerService.showToast('warning', controlMessages[control], 'Atención');
      }
    });
  }

  async printPage() {
    if (!this.validations()) return;

    if (this.quantityDetails == 0) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir el pedido interno, no tiene ningún detalle.', 'Atención');
      return;
    }

    if (this.internalOrderContract.internalOrderState === InternalOrderEnums.open) {
      this.toastHandlerService.showToast('warning', 'No es posible imprimir, el pedido interno se encuentra en estado abierto.', 'Atención');
      return;
    }

    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getPrintInternalOrders();
    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      const check = async () => {
        if (this.finishLoadingPrint) {
          print();
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [InternalOrderEnums.open]: {
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        enableConsecutive: this.internalOrderId !== 0,
      },
      [InternalOrderEnums.close]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        enableConsecutive: true,
      },
      [InternalOrderEnums.annul]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulada',
        isDisabled: true,
        enableConsecutive: true,
      },
    };

    const currentState = this.internalOrderContract.internalOrderState;
    const config = stateConfig[currentState];

    if (config) {
      this.iconState = config.icon;
      this.titleState = config.title;
      this.stateText = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = config.isDisabled;

      setTimeout(() => {
        config.isDisabled ? this.formInternalOrder.disable() : this.formInternalOrder.enable();
        const control = this.formInternalOrder.controls["consecutive"];
        config.enableConsecutive ? control.enable() : control.disable();
      }, 100);
    }
    if (!this.permissionUpdatable) setTimeout(() => this.formInternalOrder.disable(), 100);
    setTimeout(() => this.formInternalOrder.controls["branchId"].enable(), 100);
    if (this.quantityDetails > 0) {
      setTimeout(() => this.formControlStateService.setControlState(
        this.formInternalOrder, ["maintenanceOrderClass", "maintenanceOrderConsecutive"], false
      ), 100);
    }
  }

  updateQuantityDetails(quantity: number) {
    this.quantityDetails = quantity;
    this.updateFormState();
  }

  validations() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para modificar pedidos internos. Comuníquese con el administrador del sistema.', 'Atención');
      return false;
    }

    if (this.internalOrderContract.internalOrderId == 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear el encabezado del pedido interno.', 'Atención');
      return false;
    }

    if (this.disabledForm && this.internalOrderContract.internalOrderState === InternalOrderEnums.annul) {
      this.toastHandlerService.showToast('warning', 'No es posible modificar, el pedido interno no está ABIERTO', 'Atención');
      return false;
    }

    return true;
  }

  async validateForm(internalOrder: InternalOrderModel) {
    this.formInternalOrder = this.formBuilder.group({
      branchId: [internalOrder.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [internalOrder.consecutive, [Validators.required]],
      alterNumber: [internalOrder.alterNumber],
      dateInternalOrder: [internalOrder.dateInternalOrder ?
        this.dateConverterService.convertUtcToLocalDate(internalOrder.dateInternalOrder) : null, [Validators.required]],
      responsible: [internalOrder.responsible],
      observation: [internalOrder.observation, [Validators.maxLength(250)]],
      maintenanceOrderId: [internalOrder.maintenanceOrderId],
      maintenanceOrderClass: [internalOrder.maintenanceOrder ? internalOrder.maintenanceOrder.maintenanceOrderClassId : null],
      maintenanceOrderConsecutive: [internalOrder.maintenanceOrder ? internalOrder.maintenanceOrder.consecutive : null]
    });
    if (internalOrder.maintenanceOrderId && internalOrder.maintenanceOrder) {
      this.setArticle(internalOrder.maintenanceOrder.articleId);
    } else {
      this.articleCodeName = '';
    }

    if (internalOrder.internalOrderId == 0) {
      if (this.mainBranchByUser.branchId != 0) this.getBranch(this.mainBranchByUser.branchId, false);
    }
    this.updateFormState();
  }

  async getPrintInternalOrders() {
    this.internalOrderPrintModel = await firstValueFrom(this.internalOrderService.getPrintInternalOrder(this.internalOrderContract.internalOrderId));
  }

}
